import React from 'react';

import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';



const SearchIconBuilder: IconBuilder = {
	icon: ({ color = '#5C6773' }) => {
		return (
			<g
				fill="none"
				fillRule="evenodd"
				id="Page-1"
				opacity="0.7"
				stroke="none"
				strokeWidth="0.5"
			>
				<path
					d="M2.7002 8V10C2.7002 10.1657 2.83431 10.2998 3 10.2998H5V11H3C2.44772 11 2 10.5523 2 10V8H2.7002ZM12 10C12 10.5177 11.6067 10.9438 11.1025 10.9951L11 11H9V10.2998H11C11.1657 10.2998 11.2998 10.1657 11.2998 10V8H12V10ZM11.1025 3.00488C11.6067 3.05621 12 3.48232 12 4V6H11.2998V4C11.2998 3.83431 11.1657 3.7002 11 3.7002H9V3H11L11.1025 3.00488ZM5 3.7002H3C2.83431 3.7002 2.7002 3.83431 2.7002 4V6H2V4C2 3.44772 2.44772 3 3 3H5V3.7002Z"
					fill={color}
				/>
				<path
					d="M6.78223 5C7.76654 5 8.56441 5.79792 8.56445 6.78223C8.56445 7.13829 8.45818 7.46874 8.27832 7.74707L8.97949 8.44824C9.11607 8.58482 9.11586 8.80763 8.97949 8.94434C8.84279 9.08074 8.62097 9.07995 8.48438 8.94336L7.79004 8.25C7.50318 8.44734 7.15675 8.56445 6.78223 8.56445C5.79792 8.56441 5 7.76654 5 6.78223C5.00004 5.79795 5.79795 5.00004 6.78223 5ZM6.78223 5.7002C6.18455 5.70024 5.70024 6.18455 5.7002 6.78223C5.7002 7.37994 6.18452 7.86421 6.78223 7.86426C7.37997 7.86426 7.86426 7.37997 7.86426 6.78223C7.86421 6.18452 7.37994 5.7002 6.78223 5.7002Z"
					fill={color}
				/>
			</g>
		);
	},
	viewBoxHeight: 14,
	viewBoxWidth: 14,
};



export default SearchIconBuilder;

